export const AUTH_FORCE_LOGOUT_EVENT = 'auth:force-logout';

export function dispatchForceLogout(message: string) {
  window.dispatchEvent(new CustomEvent(AUTH_FORCE_LOGOUT_EVENT, { detail: { message } }));
}
